import { render, staticRenderFns } from "./TopSonIncidencesChart.vue?vue&type=template&id=56a5d508&scoped=true"
import script from "./TopSonIncidencesChart.vue?vue&type=script&lang=js"
export * from "./TopSonIncidencesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5d508",
  null
  
)

export default component.exports